export const DROP_ZONE_STATUS = {
  Pending: 'pending',
  Uploading: 'uploading',
  Success: 'success',
  Error: 'error',
} as const

export type DropZoneStatus = typeof DROP_ZONE_STATUS[keyof typeof DROP_ZONE_STATUS]

/** Default allowed extensions (from legacy main-app dropzone mixin). */
export const DROP_ZONE_ACCEPT: string[] = [
  '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx',
  '.jpeg', '.jpg', '.pdf', '.png',
  '.avi', '.mkv', '.m2a', '.m2v', '.mov', '.mp3', '.mp4', '.mpeg', '.mpg',
  '.zip',
]

/** 80 MB. */
export const DROP_ZONE_MAX_SIZE = 80 * 1024 * 1024

export const DROP_ZONE_MAX_FILES = 10
